import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";
import modelBase from "../model-base.model";

var surveyModel = {

    saveSurvey: (successCallBack, failureCallBack, params, isEdit) => {
        if (!isEdit) {
            modelBase.post(successCallBack, failureCallBack, '/api/survey', { body: params });
        } else {
            modelBase.post(successCallBack, failureCallBack, '/api/survey/update', { body: params });
        }
    },

    saveQuestions: (successCallBack, failureCallBack, params) => {
        modelBase.post(successCallBack, failureCallBack, '/api/survey/question', { body: params });
    },

    copySurvey: (successCallBack, failureCallBack, id) => {
        const params = {
            surveyID: id
        }
        Object.assign(params);

        let qs = '?' + modelBase.toQueryString(params);
        modelBase.post(successCallBack, failureCallBack, `/api/survey/copy${qs}`, { body: {} });
    },

    getQuestions: (surveyId) => {
        const params = {
            surveyID: surveyId
        }
        Object.assign(params);

        let qs = '?' + modelBaseV2.toQueryString(params);
        return modelBaseV2.get(`/api/survey/question${qs}`);
    },

    getQuestionTypes: (successCallBack, failureCallBack, type) => {
        const params = {
            surveyType: type
        }
        Object.assign(params);

        let qs = '?' + modelBase.toQueryString(params);
        modelBase.get(successCallBack, failureCallBack, `/api/survey/questionTypeBySurveyType${qs}`);
    },

    getQuestionOptions: (questionIds) => {
        let body = {
            sortBy: '',
            orderBy: '',
            pageIndex: 0,
            pageSize: 100,
            storedProcedureCode: '23',
            params: [{
                code: '65',
                value: questionIds
            }]
        };

        return modelBaseV2.post('/api/executesp/call', { body });
    },

    getResponses: (params) => {
        let qs = '?' + modelBaseV2.toQueryString(params);
        return modelBaseV2.get(`/api/survey/question/response${qs}`);
    },

    getResponseDetails: (params) => {
        let qs = '?' + modelBaseV2.toQueryString(params);
        return modelBaseV2.get(`/api/survey/question/response/details${qs}`);
    },

    updateResponses: (body) => {
        return modelBaseV2.post(`/api/survey/mobileAnswer/update`, { body });
    },

    getSurveyDetails: (successCallBack, failureCallBack, id) => {
        const params = {
            surveyID: id
        }
        Object.assign(params);

        let qs = '?' + modelBase.toQueryString(params);
        modelBase.get(successCallBack, failureCallBack, `/api/survey${qs}`);
    },

    downloadQuestionList: (successCallBack, failureCallBack, surveyId) => {
        const params = {
            surveyID: surveyId
        }
        Object.assign(params);

        let qs = '?' + modelBase.toQueryString(params);
        var path = `/api/survey/questionlist${qs}`;
        modelBase.postDownload(successCallBack, failureCallBack, path, { body: null }, "SurveyQuestionList" + ".xlsx");
    },

    downloadExcelTemplate: (successCallBack, failureCallBack) => {
        var path = '/api/survey/question/template';


        modelBase.getDownload(successCallBack, failureCallBack, path, {}, "SurveyQuestionTemplate" + ".xlsx");
    },

    uploadQuestions: (successCallBack, failureCallBack, surveyId, file) => {
        const id = {
            surveyID: surveyId
        }

        Object.assign(id);
        let qs = '?' + modelBase.toQueryString(id);

        modelBase.postDownload(successCallBack, failureCallBack, `/api/survey/question/template${qs}`, { body: file }, "result.xlsx");
    },

    downloadSurveyResults: function (successCallback, failureCallback, filter, fileName = `Survey Result - ${moment().format('YYYYMMDDHHmm')}`) {
        const fileExtension = filter.isWithPhotos ? '.zip' : '.xlsx';
        fileName = fileName.concat(fileExtension);

        modelBase.postDownload(successCallback, failureCallback, '/api/survey/file/excelSurveyResult', { body: filter }, fileName);
    },

    downloadExcel: (successCallBack, failureCallBack, requestBody, fileName) => {
        var params = {};
        var path = '/api/survey/export/tr/file';
        params.sortBy = "",
            params.orderBy = "",
            params.pageIndex = 0,
            params.pageSize = 0,
            params.storedProcedureCode = "",
            params.params = [
            ];
        Object.assign(params, requestBody);
        modelBase.postDownload(successCallBack, failureCallBack, path, { body: params }, fileName + ".xlsx");
    },

    downloadExcelForSiteLevelSummary: function (successCallBack, failureCallBack, countryCode, selectedSurveyIds) {
        let fileName = `Site Level Summary - ${moment().format('YYYYMMDDHHmm')}`;
        let requestBody = {
            storedProcedureCode: "18",
            params: [
                {
                    "code": "16",
                    "value": countryCode
                },
                {
                    "code": "53",
                    "value": selectedSurveyIds
                }
            ],
            excelSheetNames: [
                "TARGET STORE SUMMARY DETAIL",
                "TARGET STORE SUMMARY",
                "TARGET STORE LIST"
            ]
        }
        this.downloadExcel(successCallBack, failureCallBack, requestBody, fileName);
    },

    downloadExcelForTargetResponse: function (successCallBack, failureCallBack, params) {
        let fileName = `Target Response - ${moment().format('YYYYMMDDHHmm')}`;
        let requestBody = {
            storedProcedureCode: "19",
            params: [
                {
                    "code": "16", // InputCountryCode
                    "value": params.countryCode
                },
                {
                    "code": "54", // SurveyID
                    "value": params.surveyId
                },
                {
                    "code": "8", // FromDate
                    "value": params.fromDate
                },
                {
                    "code": "9", // ToDate
                    "value": params.toDate
                }
            ],
            excelSheetNames: [
                "TARGET STORE LIST",
                "RESPONSE DETAIL",
                "RESPONSE SUMMARY",
                "RESPONSE SUMMARY DETAIL"
            ]
        }
        this.downloadExcel(successCallBack, failureCallBack, requestBody, fileName);
    },

    getSurveyList: function (successCallback, failureCallback, filter) {
        // Set required default values
        const params = {
            pageIndex: 1,
            pageSize: 10,
        }

        Object.assign(params, filter);
        let qs = '?' + modelBase.toQueryString(params);

        modelBase.get(successCallback, failureCallback, `/api/survey/list${qs}`);
    },

    getSurveyById: function (successCallback, failureCallback, surveyId = "") {
        surveyId = encodeURIComponent(surveyId);
        modelBase.get(successCallback, failureCallback, '/api/survey?surveyId=' + surveyId);
    },

    exportSurveyToPptx: function (successCallback, failureCallback, filter, fileName = `Survey - ${moment().format('YYYYMMDDHHmm')}.pptx`) {
        modelBase.postDownload(successCallback, failureCallback, '/api/survey/file/pptx', { body: filter }, fileName);
    },

    exportSurveyToExcel: function (successCallback, failureCallback, filter, fileName = `Survey - ${moment().format('YYYYMMDDHHmm')}.xlsx`) {
        modelBase.postDownload(successCallback, failureCallback, '/api/survey/file/excel', { body: filter }, fileName);
    },

    checkUploadSites: (successCallBack, failureCallBack, file) => {

        modelBase.post(successCallBack, failureCallBack, '/api/site/excelUploadCheck', { body: file });
    },

    getBackDateDetails: (successCallBack, failureCallBack) => {
        modelBase.get(successCallBack, failureCallBack, '/api/survey/backDateConf');
    },

    getQuestionsPublic: (publicSurveyGuid) => {
        return modelBaseV2.getPublic('/api/survey/public/:publicSurveyGuid', { params: { publicSurveyGuid } });
    },

    submitSurveyPublic: (publicSurveyGuid, formData) => {
        return modelBaseV2.postPublic('/api/survey/public/:publicSurveyGuid/submit', { params: { publicSurveyGuid }, body: formData });
    }
}

export default surveyModel;
